/**
 * Key for a locally captured scene snapshot, held in `sceneEditor.previews` between the
 * capture and the uploaded derivative coming back from the server.
 *
 * Portrait and landscape snapshots write to different fields on the scene config
 * (`pImageId` / `imageId`), so they are held separately here too.
 *
 * Lives in its own module so selectors can key into the store without importing the
 * slice (whose saga imports selectors in turn).
 */
export const scenePreviewKey = (sceneConfigId: number, portrait?: boolean) =>
  `${sceneConfigId}:${portrait ? 'p' : 'l'}`;

export interface IScenePreviewCapture {
  /** Object URL of the captured canvas blob. */
  url: string;
  /**
   * The scene config's image at capture time. Once the config points somewhere else the
   * upload has landed, so the snapshot is stale and the stored image takes over again.
   */
  imageId: number;
}
